import { ComponentPropsWithoutRef } from 'react'

export function LogoCodepen20(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <path d="M18.281 11.438 16.132 10l2.149-1.438zm-7.422 6.096v-4.008l3.727-2.492 3.008 2.011zm-.859-5.5L6.961 10 10 7.966 13.04 10zm-.859 5.5-6.734-4.489 3.008-2.01 3.726 2.491zM1.719 8.562 3.869 10l-2.15 1.438zm7.422-6.097v4.01L5.415 8.965 2.407 6.954zm1.718 0 6.735 4.49-3.008 2.011-3.727-2.492zm9.126 4.338a.86.86 0 0 0-.368-.565L10.477.144a.86.86 0 0 0-.954 0L.383 6.238A.87.87 0 0 0 0 6.953v6.093c0 .282.148.56.383.715l9.14 6.094a.86.86 0 0 0 .954 0l9.14-6.094a.86.86 0 0 0 .383-.715V6.953a.6.6 0 0 0-.015-.15" />
    </svg>
  )
}
